// src/components/alert/PackageUpgrade.tsx

import { Alert, Stack, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { FolderId } from '@/types/domain'

import { useBridgeId, useUserApi } from '../../hooks'

type PackageUpgradeProps = {
  id: FolderId
}

export const PackageUpgrade = ({ id }: PackageUpgradeProps) => {
  const bridgeId = useBridgeId(id)
  const { getCoachData } = useUserApi()
  const [coach, setCoach] = useState(null)
  const theme = useTheme()
  const color = theme.palette.primary.main

  useEffect(() => {
    const getCoach = async id => {
      const data = await getCoachData(id)
      setCoach(data)
    }

    getCoach(bridgeId)
  }, [bridgeId, getCoachData])

  if (!coach?.attributes) return <Stack />

  const { firstname, lastname, email_contact, telephone, telephone_mobile } =
    coach.attributes

  return (
    <Alert severity={'info'} sx={{ mb: 5 }}>
      <Typography sx={{ letterSpacing: 1, fontWeight: 'bold' }}>
        Bei Rückfragen kontaktieren Sie bitte Ihren Ansprechpartner!
      </Typography>

      <Typography
        sx={{
          letterSpacing: 2,
          fontWeight: 'bold',
          mt: 5,
          mb: 2,
        }}
      >
        {firstname} {lastname}
      </Typography>

      <Typography>
        Telefon:{' '}
        {telephone ? (
          <Link style={{ color }} to={`tel:${telephone}`}>
            {telephone}
          </Link>
        ) : (
          '-'
        )}
      </Typography>

      <Typography>
        Mobil:{' '}
        {telephone_mobile ? (
          <Link style={{ color }} to={`tel:${telephone_mobile}`}>
            {telephone_mobile}
          </Link>
        ) : (
          '-'
        )}
      </Typography>

      <Typography>
        Mail:{' '}
        {email_contact ? (
          <Link style={{ color }} to={`mailto:${email_contact}`}>
            {email_contact}
          </Link>
        ) : (
          '-'
        )}
      </Typography>
    </Alert>
  )
}
